import { useMutation } from '@tanstack/react-query'

import { integrationAPI } from '@/api/new-api'
import { resetQueries } from '@/utils'

import { getBrivoConnectionQueryKey } from './get-brivo-connection'

type UpdateBrivoConnectionRequest = {
  buildingId: number
  clientId: string
  clientSecret: string
  sdkClientId: string
  sdkClientSecret: string
  apiKey: string
  username: string
  password: string
}

const updateBrivoConnection = async (data: UpdateBrivoConnectionRequest) => {
  const response = await integrationAPI.post('/brivo/create', data)
  return response.data
}

export const useUpdateBrivoConnection = () =>
  useMutation({
    mutationFn: updateBrivoConnection,
    onSuccess: async (_data, variables) => {
      await resetQueries([getBrivoConnectionQueryKey({ buildingId: variables.buildingId })])
    },
  })
